"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getArtifactVersion = void 0;
function getArtifactVersion(artifactName, location) {
    var hostname = location.hostname, pathname = location.pathname;
    var artifactMatchRe = new RegExp("\\/.*?\\/".concat(artifactName, "/(\\d+\\.\\d+\\.\\d+)\\/"));
    var match = artifactMatchRe.exec(pathname);
    var isOnLocalWix = hostname.indexOf('local') > -1 && hostname.indexOf('wix') > -1;
    var version = match ? match[1] : isOnLocalWix ? 'local' : window['__ARTIFACT_VERSION__'] || 'other';
    return "".concat(artifactName, "#").concat(version);
}
exports.getArtifactVersion = getArtifactVersion;
//# sourceMappingURL=get-artifact-version.js.map